


















import { Component,  Vue, Prop } from 'vue-property-decorator';
import { detail, cars } from '@/api/api';
import { Notify } from 'vant';
import loading from '@/components/loading/loading2.vue';

@Component({
    name: 'info',
    components: {
        loading
    }
})

export default class Info extends Vue {
    private stations: any[] = [];
    private cars: any[] = [];
    private timer: any = undefined;
    private loading: boolean = true;

    // mounted
    private mounted() {
        const lineId = this.$route.query.lineId;
        const direction = this.$route.query.direction;
        const areaCode = localStorage.getItem('areaCode');
        detail({lineId, direction, areaCode}).then((res: any) => {
            const busStations: any[] = res.data.busStations;
            let lisCount = 0;
            const forCount = Math.ceil(busStations.length / 5);
            for (let i = 0; i < forCount; i++) {
                for (let j = 0; j < 5; j++) {
                    if (i % 2 === 0) {
                        busStations[lisCount].float = 'fl';
                    } else {
                        busStations[lisCount].float = 'fr';
                    }
                    lisCount++;
                    if (lisCount === busStations.length) {
                        break;
                    }
                }
            }
            busStations.forEach((s: any, i: number) => {
                s.arrive = 'arrive';
                s.bus = false;
                s.iostatus = -1;
                s.bugtag = '';
                s.lend = '';
                if (!(i === busStations.length - 1)) {
                    if ((i + 1) % 5 === 0) {
                        s.leave = 'leave2';
                        s.marrive = 'marrive2';
                        s.mleave = 'mleave2';
                    } else {
                        if (Math.floor((i + 1) / 5) % 2 === 0) {
                            s.leave = 'leave1';
                            s.marrive = 'marrive1';
                            s.mleave = 'mleave1';
                        } else {
                            s.leave = 'leave3';
                            s.marrive = 'marrive3';
                            s.mleave = 'mleave3';
                        }
                    }
                }
                if (i === busStations.length - 1) {
                    s.lend = s.float === 'fl' ? 'lend2' : 'lend1';
                }
            });
            this.stations = busStations;
            this.loading = false;
            this.getCars();
            this.timer = setInterval(() => {
                this.getCars();
            }, 3000);
        });
    }

    // beforeDestroy
    private beforeDestroy() {
        clearInterval(this.timer);
    }

    // methods
    // 获取车辆位置
    private getCars(): void {
        const areaCode = localStorage.getItem('areaCode');
        const direction = this.$route.query.direction;
        const lineCode = this.$route.query.lineCode;
        cars({areaCode, direction, lineCode}).then((res: any) => {
            const cars: any[] = res.data;
            this.cars = cars;
            const stations: any[] = this.stations;
            // console.log(cars);
            // console.log(stations);
            stations.forEach((s: any) => {
                s.bus = false;
                s.iostatus = -1;
                s.bugtag = '';
            });
            cars.forEach((c: any) => {
                stations[c.sno - 1].bus = true;
                stations[c.sno - 1].iostatus = c.iostatus;
                stations[c.sno - 1].bugtag = c.bugtag;
            });
            this.stations = stations;
        });
    }
    // 地图
    private goMap(): void {
        const lineId = this.$route.query.lineId;
        const direction = this.$route.query.direction;
        const lineCode = this.$route.query.lineCode;
        this.$router.push({
            path: '/map',
            query: {
                lineId,
                direction,
                lineCode
            }
        });
    }
    // 显示车辆信息
    private showCar(val: string): void {
        Notify({
            message: val,
            duration: 2000,
            background: '#1989fa'
        });
    }
    // 预计到达时间
    private getArriveTime(sitenum: number): void {
        let cars: any[] = JSON.parse(JSON.stringify(this.cars));
        cars = cars.sort(this.compare('sno'));
        const eNum: number = sitenum;
        let sNum: number = -1;
        if (sitenum > 1) {
            // console.log(cars);
            if (sitenum > cars[cars.length - 1].sno) {
                sNum = cars[cars.length - 1].sno;
            } else {
                for (let i = 1; i < cars.length; i++) {
                    if (cars[i - 1].sno < sitenum && sitenum <= cars[i].sno) {
                        let num: number = i - 1;
                        num = num > 0 ? num : 0;
                        sNum = cars[num].sno;
                        break;
                    }
                }
            }
        }
        let tips: string = '';
        if (sNum > -1) {
            const minutes: number = this.newArriveTime(sNum, eNum);
            tips = `预计${minutes}分钟到达`;
        } else {
            tips = `暂无信息`;
        }
        Notify({
            message: tips,
            duration: 2000,
            background: '#1989fa'
        });
    }
    private newArriveTime(sNum: number, eNum: number): number {
        const timeArray: any = {
            1: 2,
            2: 5,
            3: 7,
            4: 10,
            5: 12,
            6: 14,
            7: 15,
            8: 18,
            9: 20
        };
        const count = Math.abs(sNum - eNum);
        let minutes = 0;
        if (count > 9) {
            minutes = count * 2 + 1;
        } else {
            minutes = timeArray[count];
        }
        return minutes;
    }
    private compare(property: string): any { 
        return (a: any, b: any) => { 
            const value1 = a[property]; 
            const value2 = b[property]; 
            return value1 - value2; 
        };
    }
}
